module.exports = __webpack_public_path__ + "static/media/seventeenth_henry_social_club.8044ef9c.mp4";